<template>
  <div class="tokamak-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$P = k · n · T · τE$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>等离子体温度 T</label>
            <span class="val">{{ temp.toFixed(1) }} 亿℃</span>
          </div>
          <div class="hud-item emerald">
             <label>磁场稳定性</label>
             <span class="val">{{ stability.toFixed(1) }}%</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 400 240" preserveAspectRatio="xMidYMid meet">
          <!-- 托卡马克真空室 (甜甜圈形状截面) -->
          <ellipse cx="200" cy="120" rx="120" ry="80" fill="none" stroke="#334155" stroke-width="40" stroke-opacity="0.3" />
          
          <!-- 纵场线圈 (D型线圈) -->
          <rect v-for="i in 8" :key="'c'+i" 
                x="80" y="40" width="240" height="160" 
                fill="none" stroke="#64748b" stroke-width="2" rx="60" 
                :transform="`rotate(${i*45} 200 120) scale(0.8)`" opacity="0.4" />

          <!-- 等离子体螺旋流 -->
          <path :d="plasmaPath" fill="none" stroke="url(#plasma-grad)" stroke-width="15" stroke-linecap="round" filter="url(#glow)">
             <animate attributeName="stroke-dashoffset" from="400" to="0" dur="1.5s" repeatCount="indefinite" />
          </path>

          <defs>
            <linearGradient id="plasma-grad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style="stop-color:#f43f5e;stop-opacity:0.2" />
              <stop offset="50%" style="stop-color:#fbbf24;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#3b82f6;stop-opacity:0.2" />
            </linearGradient>
            <filter id="glow"><feGaussianBlur stdDeviation="3.5" result="coloredBlur"/><feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
          </defs>
        </svg>

        <div class="physics-caption">
          <strong>物理规律：</strong>托卡马克利用螺旋形强磁场将极高温的等离子体约束在真空室中心，使其脱离器壁悬浮，从而满足劳逊判据实现可持受控聚变。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="label-row"><span class="label">调节劳逊判据：磁约束强度</span></div>
           <el-slider v-model="magneticFlux" :min="10" :max="100" size="small"></el-slider>
        </div>
        
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-sunny"></i>
           <p><strong>实战物理：</strong>这就是“人造太阳”的核心。<strong>观察：</strong>随着磁约束强度（滑块）增大，等离子体流（变色轨道）会更加紧凑且稳定。聚变反应要求的亿级高温，只有在这种磁阱中才能维持。
           </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'TokamakFusionViz',
  data() {
    return {
      magneticFlux: 65
    }
  },
  computed: {
    temp() { return this.magneticFlux * 1.5 + 50; },
    stability() { return this.magneticFlux * 0.95; },
    plasmaPath() {
       // 模拟环形扭转路径
       const rx = 100 + (100 - this.magneticFlux)/5;
       const ry = 60 + (100 - this.magneticFlux)/5;
       return `M 200,${120-ry} A ${rx},${ry} 0 1,1 200,${120+ry} A ${rx},${ry} 0 1,1 200,${120-ry}`;
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.tokamak-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
